import _ from 'lodash'
import statusCode from './statusCode'

export const weekdays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export function marshalStoreHours(data) {
  weekdays.forEach(day => {
    const dayShort = day.substring(0, 3)
    const field = `${dayShort}Hours`
    const openHour = data[`${day}OpenHour`] || '12'
    const openMinute = data[`${day}OpenMinute`] || '00'
    const openAm = data[`${day}OpenAm`] || 'AM'
    const closeHour = data[`${day}CloseHour`] || '12'
    const closeMinute = data[`${day}CloseMinute`] || '00'
    const closeAm = data[`${day}CloseAm`] || 'AM'
    data[
      field
    ] = `${openHour},${openMinute},${openAm},${closeHour},${closeMinute},${closeAm}`
  })
}

export function unmarshalStoreHours(data) {
  weekdays.forEach(day => {
    const dayShort = day.substring(0, 3)
    const fields = (data[`${dayShort}Hours`] || '').split(',')
    const [
      openHour = '12',
      openMinute = '00',
      openAm = 'AM',
      closeHour = '12',
      closeMinute = '00',
      closeAm = 'PM'
    ] =
      fields.length === 6 ? fields : []
    data[`${day}OpenHour`] = openHour
    data[`${day}OpenMinute`] = openMinute
    data[`${day}OpenAm`] = openAm
    data[`${day}CloseHour`] = closeHour
    data[`${day}CloseMinute`] = closeMinute
    data[`${day}CloseAm`] = closeAm
  })
}

export const isStandardRetailer = retailer => {
  // currentUser can be an Entity (has .get), a raw JSON:API object (has
  // .attributes), or the plain object restored from localStorage
  // ({ type, id, username, retailerType }).
  const type = _.isFunction(retailer.get)
    ? retailer.get('retailerType')
    : retailer.attributes
      ? retailer.attributes.retailerType
      : retailer.retailerType
  return type === '' || type === 'standard'
}

export const {
  statusCodes,
  statusCodeToText,
  statusTextToCode
} = statusCode.retailer
